module.exports = __webpack_public_path__ + "media/images/landing_pages/taiwan_travel-0aa0a2683497323bb627f923770ffb67.svg";